// extracted by mini-css-extract-plugin
export default {"monitor":"styles_monitor__eusvA"};